import { node, oneOfType, oneOf, checkPropTypes } from "prop-types";
const headerPropTypeValidation = (props, propName, componentName) => {
  if (propName === "header" && props[propName] !== null && props[propName]?.type?.displayName !== "ModalHeader") {
    console.warn(`@ingka/modal: header propType only accepts ModalHeader component instance or null. If null is provided, additional CSS must be added to ensure a minimum top-padding for the content.
Leaving the header propType value as it is may cause the component to not function as intended.`);
  }
  return checkPropTypes({
    header: oneOfType([
      oneOf([null]).isRequired,
      node
    ])
  }, props, "prop", componentName);
};
var headerPropTypeValidation_default = headerPropTypeValidation;
export {
  headerPropTypeValidation_default as default
};
